import React, { useEffect, useState } from "react";
import Card from "components/Card";
import PagingTable from "components/Table/Paging";
import axios from "axios";
import { columns } from "./config";
import _ from "lodash";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { useModal } from "components/Modal/Simple";
import MultiBadgeCombo from "components/Form/MultiBadgeCombo";
import Input from "components/Form/Input";
import { infoService } from "common/services/info";
import Button from "components/Form/Button";
import SpinnerMedium from "components/Spinner/Medium";
import { staffClient } from "common/apis/staff";

const EditConcernsForm = ({ externalData = null, closeModal = () => { }, resolveRef = null }) => {
    console.log("[EditConcernsForm] externalData", externalData);
    const [concernItems, setConcernItems] = useState(null);
    const [selectedConcernItems, setSelectedConcernItems] = useState([]);

    useEffect(() => {
        console.log("[EditConcernsForm] useEffect", infoService.getConcerns());
        const concerns = infoService.getConcerns();
        setConcernItems(concerns);
        setSelectedConcernItems(externalData.concerns);
    }, [])

    const onSubmit = () => {
        console.log("[EditPartsForm] onSubmit", selectedConcernItems);
        resolveRef.current(selectedConcernItems);
    }

    if (_.isNil(concernItems)) {
        return <SpinnerMedium />
    }

    return (
        <div>
            <div className="flex flex-col space-y-2">
                <div>
                    <div className="font-semibold">
                        시술부위명
                    </div>
                    <Input
                        disabled={true}
                        value={externalData.name}
                    />
                </div>
                <div>
                    <div className="font-semibold">
                        고민명
                    </div>
                    <MultiBadgeCombo
                        items={concernItems}
                        selectedItems={selectedConcernItems}
                        onSelectedItemsChange={setSelectedConcernItems}
                    />
                </div>
                <div className="border-t border-gray-300"></div>
                <div className="flex justify-end">
                    <div>
                        <Button
                            onButtonClicked={onSubmit}
                        >
                            저장
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const EditTreatmentsForm = ({ externalData = null, closeModal = () => { }, resolveRef = null }) => {
    console.log("[EditTreatmentsForm] externalData", externalData);
    const [treatmentItems, setTreatmentItems] = useState(null);
    const [selectedTreatmentItems, setSelectedTreatmentItems] = useState([]);

    useEffect(() => {
        console.log("[EditTreatmentsForm] useEffect", infoService.getTreatments());
        const treatments = infoService.getTreatments();
        setTreatmentItems(treatments);
        setSelectedTreatmentItems(externalData.treatments);
    }, [])

    const onSubmit = () => {
        console.log("[EditTreatmentsForm] onSubmit", selectedTreatmentItems);
        resolveRef.current(selectedTreatmentItems);
    }

    if (_.isNil(treatmentItems)) {
        return <SpinnerMedium />
    }

    return (
        <div>
            <div className="flex flex-col space-y-2">
                <div>
                    <div className="font-semibold">
                        시술부위명
                    </div>
                    <Input
                        disabled={true}
                        value={externalData.name}
                    />
                </div>
                <div>
                    <div className="font-semibold">
                        시술명
                    </div>
                    <MultiBadgeCombo
                        items={treatmentItems}
                        selectedItems={selectedTreatmentItems}
                        onSelectedItemsChange={setSelectedTreatmentItems}
                    />
                </div>
                <div className="border-t border-gray-300"></div>
                <div className="flex justify-end">
                    <div>
                        <Button
                            onButtonClicked={onSubmit}
                        >
                            저장
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const PartPage = () => {
    const [refreshKey, setRefreshKey] = useState(_.uniqueId());
    const { Modal: EditConcernsModal, openModalSync: openEditConcernsModal, closeModal: closeEditConcernsModal } = useModal();
    const { Modal: EditTreatmentsModal, openModalSync: openEditTreatmentsModal, closeModal: closeEditTreatmentsModal } = useModal();

    const fetchData = async (page, limit) => {
        try {
            const params = {
                offset: (page - 1) * limit,
                limit: limit
            }
            // const ret = await axios.get(`https://rest.miview.shop/part`, { params });
            const ret = await staffClient.get("/part", { params });
            const { data, total } = ret.data;
            return {
                data,
                page,
                total
            }
        } catch (e) {
            console.log("[PartPage] fetchData error", e);
            return {
                data: null,
                page,
                total: 0
            }
        }
    }

    const postData = async (row) => {
        try {
            // const ret = await axios.post(`https://rest.miview.shop/part`, row);
            const ret = await staffClient.post("/part", row);
            return ret.data;
        } catch (e) {
            console.log("[PartPage] postData error", e);
            return null;
        }
    }

    const patchConcernData = async (row, updateItems) => {
        try {
            const partId = row.id;
            console.log("[patchConcernData] req", partId, updateItems);
            const concernIds = updateItems.map((item) => item.id);
            // const ret = await axios.patch(`https://rest.miview.shop/part/${partId}/concerns`, { concernIds });
            const ret = await staffClient.patch(`/part/${partId}/concerns`, { concernIds });
            console.log("[patchConcernData] ret", ret);
            return true;
        } catch (e) {
            console.log("[ConcernPage] patchConcernData error", e);
            return null;
        }
    }

    const patchTreatmentsData = async (row, updateItems) => {
        try {
            const partId = row.id;
            console.log("[patchTreatmentsData] req", partId, updateItems);
            const treatmentIds = updateItems.map((item) => item.id);
            // const ret = await axios.patch(`https://rest.miview.shop/part/${partId}/treatments`, { treatmentIds });
            const ret = await staffClient.patch(`/part/${partId}/treatments`, { treatmentIds });
            console.log("[patchTreatmentsData] ret", ret);
            return true;
        } catch (e) {
            console.log("[ConcernPage] patchTreatmentsData error", e);
            return null;
        }
    }

    const onCreate = async (row) => {
        console.log("[PartPage] onCreate", row);
        const ret = await postData(row);
        if (ret) {
            setRefreshKey(_.uniqueId());
            return true;
        }
    }

    const onEditConcernClicked = async (row) => {
        console.log("[onEditConcernClicked] row", row);
        const modalRet = await openEditConcernsModal(row);
        console.log("[onEditConcernClicked] ret", modalRet);
        const patchRet = await patchConcernData(row, modalRet);
        if (patchRet) {
            setRefreshKey(_.uniqueId());
            closeEditConcernsModal();
            return true;
        }
    }

    const onEditTreatmentsClicked = async (row) => {
        console.log("[onEditTreatmentsClicked] row", row);
        const modalRet = await openEditTreatmentsModal(row);
        console.log("[onEditTreatmentsClicked] ret", modalRet);
        const patchRet = await patchTreatmentsData(row, modalRet);
        if (patchRet) {
            setRefreshKey(_.uniqueId());
            closeEditTreatmentsModal();
            return true;
        }
    }

    const columnsWithActions = columns.map((col) => {
        if (col.field === "concerns") {
            return {
                ...col,
                render: (value, field, row) => (
                    <div className="flex space-x-2 items-center cursor-pointer" onClick={() => { onEditConcernClicked(row) }}>
                        <PencilSquareIcon className="size-4 align-center"></PencilSquareIcon>
                        <span>{row.concerns.map((item: any) => item.name).join(", ")}</span>
                    </div>
                )
            }
        }
        else if (col.field === "treatments") {
            return {
                ...col,
                render: (value, field, row) => (
                    <div className="flex space-x-2 items-center cursor-pointer" onClick={() => { onEditTreatmentsClicked(row) }}>
                        <PencilSquareIcon className="size-4 align-center"></PencilSquareIcon>
                        <span>{row.treatments.map((item: any) => item.name).join(", ")}</span>
                    </div>
                )
            }
        }
        else {
            return col;
        }
    });

    return (
        <Card>
            <div className="p-3">
                <PagingTable
                    fetchData={fetchData}
                    columns={columnsWithActions}
                    refreshKey={refreshKey}
                    windowSize={100}
                    isCrudable={true}
                    onCreate={onCreate}
                />
            </div>
            <EditConcernsModal>
                <EditConcernsForm />
            </EditConcernsModal>
            <EditTreatmentsModal>
                <EditTreatmentsForm />
            </EditTreatmentsModal>
        </Card>
    )
};

export default PartPage;

